<template>
  <!-- 企业钱包 -->
  <div class="firm-body">
    <!-- 标题 企业钱包 -->
    <div class="title-Individual-center">
      企业中心 <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">企业钱包</span>
    </div>
    <!-- 主体部分 -->
    <div class="firm-Content-subject">
      <!-- 充值 -->
      <div class="top-up">
        <div class="balance">
          <div class="balance-top balance-public">
            <div class="icon"></div>
            <span v-if="accountStatus == '1'">侦迹币</span>
            <span v-if="accountStatus == '0'" style="color: #c1c1c1"
              >侦迹币已冻结</span
            >
            <span v-if="accountStatus == '1'" class="balance-amount">{{ balance }}</span>
            <span v-if="accountStatus == '0'" class="balance-amount" style="color: #c1c1c1">
              {{ balance }}
            </span>
          </div>
        </div>
        <!-- 充值按钮 -->
        <div class="top-up-btn" v-if="accountStatus == '1'">
          <el-button type="primary" class="top-up-action" @click="handelTopUp">充值</el-button>
          <div class="top-up-tip">1rmb=1侦迹币</div>
        </div>
        <div class="top-up-btn" v-else>
          <el-button type="primary" class="top-up-action" @click="handelFreeze">查看冻结原因</el-button>
          <div class="top-up-tip">侦迹币已冻结</div>
        </div>
      </div>
      <!-- 标题 -->
      <div class="title">充值/消费记录</div>
      <!-- 筛选 -->
      <el-form class="screen" :inline="true" @submit.native.prevent>
      <el-form-item label="时间：">
      <el-date-picker
      v-model="value1"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      unlink-panels
      clearable
      @clear="value1 = null"
      >
      </el-date-picker>
      </el-form-item>
      <el-form-item label="支付类型：" class="user-Id">
      <div class="size-search">
      <el-select v-model="value" placeholder="请选择" clearable>
      <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      >
      </el-option>
      </el-select>
      </div>
      </el-form-item>
      <el-form-item label="消费类型：" class="user-Id">
      <div class="size-search">
      <el-select v-model="consumptionType" placeholder="请选择" clearable>
      <el-option
      v-for="item in consumptionTypeOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      >
      </el-option>
      </el-select>
      </div>
      </el-form-item>
      
      <div class="screen-end">
      <el-form-item label="消费金额：" class="user-Id">
      <div class="size-search">
      <el-input v-model="input" placeholder="请输入"></el-input>
      </div>
      </el-form-item>
      <el-form-item>
      <el-button type="primary" class="ser-btn public-style" @click="handelSearch">搜 索</el-button>
      <el-button class="heavy-btn public-style" @click="handelReset">重 置</el-button>
      </el-form-item>
      </div>
    
    </el-form>
      <!-- 表格 -->
      <div class="tabulation">
        <tablePurse :tableData="tableData"></tablePurse>
      </div>
      <!-- 底部分页 -->
      <div class="paging-box">
        <div class="paging">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </div>
    <TopUpWindow
      :dialogVisible="dialogVisible"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
      @handleSuccess="handleSuccess"
    ></TopUpWindow>
    <!-- 冻结原因 -->
    <ReasonWin
      :dialogReason="dialogReason"
      :Instruction="reason"
      :title="'冻结原因'"
      @handleCloseReason="dialogReason = false"
    ></ReasonWin>
  </div>
</template>

<script>
import {
  selectCompanyWalletList, //企业钱包列表
  getSysDefaultUserImg, // 获取系统默认头像
} from "../../../../assets/api/firm/firmCenter";
// 引入充值弹窗
import TopUpWindow from "./components/TopUpWindow.vue";
// 引入表格
import tablePurse from "./components/tablePurse.vue";
// 引入分页组件
import paging from "../../../../components/paging.vue";
// 引入展示原因组件
import ReasonWin from "../firmAccount/components/ReasonWin.vue";
export default {
  data() {
    return {
      input: "", // 消费金额（界面正数，请求时转负数）
      value1: null, // 时间
      value: null, // 支付类型 payMethod
      consumptionType: null, // 消费类型
      options: [
        { value: 1, label: "支付宝" },
        { value: 2, label: "微信" },
        { value: 3, label: "侦迹币" },
        { value: 4, label: "系统" },
        { value: 5, label: "发票豆" },
      ], // 支付类型：ALIPAY(1)/WECHAT(2)/TRACE_COIN(3)/SYSTEM(4)
      consumptionTypeOptions: [
        { value: 0, label: "道具" },
        { value: 1, label: "代理服务" },
        { value: 2, label: "充值" },
        { value: 3, label: "增值服务" },
        { value: 4, label: "广告服务" },
        { value: 5, label: "系统" },
      ],
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      },
      dialogVisible: false, // 充值弹窗开启关闭
      tableData: [
        // {
        //   orderNumber: "--", //订单
        // },
        // {
        //   orderNumber: "--", //订单
        // },
      ], // 列表数据
      balance: "0", // 侦迹币余额
      accountStatus: "", //侦迹币状态 0冻结 1开启
      reason: "", //冻结原因
      dialogReason: false, //原因弹窗
    };
  },
  components: {
    paging,
    TopUpWindow,
    tablePurse,
    ReasonWin,
  },
  created() {
    this.selectCompanyWalletList();
  },
  methods: {
    // 冻结原因
    handelFreeze() {
      if (!this.$checkAction()) return;
      this.dialogReason = true;
    },
    // 充值完成
    handleSuccess() {
      this.dialogVisible = false;
      this.selectCompanyWalletList();
    },
    // 组装查询参数（对齐后台企业钱包详情 / selectCompanyWalletList）
    buildQueryData() {
      const data = {
        companyId: Number(this.$store.getters.getCompany.id), // 公司ID 必需
      };
      const range = this.value1;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        data.startTime = range[0] + " 00:00:00";
        data.endTime = range[1] + " 23:59:59";
      }
      if (this.value !== "" && this.value != null) {
        data.payMethod = Number(this.value); // 支付类型
      }
      if (this.consumptionType !== "" && this.consumptionType != null) {
        data.consumptionType = Number(this.consumptionType); // 消费类型
      }
      // 消费人民币需转成负数传给后端
      if (this.input !== "" && this.input != null) {
        const amount = Math.abs(Number(this.input));
        if (!isNaN(amount) && amount > 0) {
          data.consumption = -amount;
        }
      }
      return data;
    },
    // 企业钱包列表 数据 接口
    selectCompanyWalletList() {
      var data = {
        data: this.buildQueryData(),
      };
      selectCompanyWalletList(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.userWalletRecord.list;
          this.pagingObj.totalDevice = res.data.userWalletRecord.total;
          this.balance = res.data.traceCoin;
          // 状态
          this.accountStatus = res.data.accountStatus;
          // 冻结原因
          this.reason = res.data.reason;
        }
      });
    },
    // 搜索按钮
    handelSearch() {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      };
      this.selectCompanyWalletList();
    },
    // 重置按钮
    handelReset() {
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      };
      this.value = null;
      this.consumptionType = null;
      this.value1 = null;
      this.input = "";
      this.selectCompanyWalletList();
    },
    // 点击充值侦迹币
    handelTopUp() {
      if (!this.$checkAction()) return;
      this.dialogVisible = true;
    },
    // 关闭充值弹窗
    handleClose() {
      this.dialogVisible = !this.dialogVisible;
    },
    // 充值弹窗点击确定
    handleUnderstand() {
      this.dialogVisible = !this.dialogVisible;
    },
    // 分页
    handleCurrentChange(num) {
      // num 要跳转的页面
      this.pagingObj.currentPage = num;
      // 调用数据接口
      this.selectCompanyWalletList();
    },
  },
};
</script>

<style scoped lang="less">
.firm-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // 充值
  .top-up {
    display: flex;
    width: 100%;
    .balance {
      width: 250px;
      height: 60px;
      line-height: 60px;
      border: 1px solid #409eff ;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      .balance-public {
        width: 100%;
        height: 30px;
        line-height: 30px;
        display: flex;
      }
      .balance-top {
        position: relative;
        margin: auto 0;
        .icon {
          width: 20px;
          height: 20px;
          margin: auto 0;
          margin-left: 20px;
          margin-right: 10px;
          background-image: url("../../../../assets/imgs/qianbao@3x.svg");
          background-size: 100% 100%;
        }
        span {
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #409eff ;
          font-weight: 400;
        }
        .balance-amount {
          position: absolute;
          right: 14px;
          font-size: 16px;
          color: #fe574a;
          font-weight: 400;
        }
      }
    }
    .top-up-btn {
      width: 100px;
      height: 60px;
      margin-left: 67px;
      flex-direction: column;
      text-align: center;
      display: flex;
      .top-up-action {
        width: 100px !important;
        height: 35px !important;
        padding: 0 !important;
        line-height: 35px !important;
        background: #409eff !important;
        border-color: #409eff !important;
        border-radius: 5px;
        font-size: 14px;
        color: #ffffff !important;
        font-weight: 400;
      }
      .top-up-tip {
        font-size: 12px;
        color: #333333;
        font-weight: 400;
        line-height: 35px;
      }
    }
  }
  // 标题
  .title {
    height: 18px;
    line-height: 18px;
    margin-top: 30px;
    font-size: 16px;
    color: #333333;
    font-weight: 400;
    font-family: PingFangSC-Medium;
  }
  .screen {
    margin-top: 15px;
  }
  // 表格
  .tabulation {
    width: 100%;
    min-height: 530px;
    box-sizing: border-box;
    margin-top: 30px;
  }
  // 分页
  .paging-box {
    width: 100%;
    height: 22px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    .paging {
      width: 90%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
